var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeezer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 33,
    viewBox: "0 0 168 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_19484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3301 21.32C39.3301 28.06 43.4801 32.09 49.6501 32.09C52.7201 32.09 55.3101 31.23 56.7601 28.98V32.06H62.3901V0H56.5401V13.64C55.2101 11.39 52.7601 10.38 49.6901 10.38C43.6901 10.38 39.3401 14.48 39.3401 21.32H39.3301ZM56.7201 21.32C56.7201 25.17 54.1001 27.57 50.9601 27.57C47.8201 27.57 45.2001 25.17 45.2001 21.32C45.2001 17.47 47.7201 14.95 50.9601 14.95C54.2001 14.95 56.7201 17.44 56.7201 21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5699 23.8C80.3348 24.9246 79.6968 25.9245 78.7759 26.6114C77.855 27.2984 76.7148 27.6251 75.5699 27.53C72.4599 27.53 69.9099 25.65 69.8399 22.32H84.5699C84.758 21.4495 84.8485 20.5606 84.8399 19.67C84.8399 13.67 80.7699 10.35 74.7799 10.35C73.3496 10.2828 71.9209 10.5128 70.5839 11.0256C69.247 11.5383 68.0309 12.3226 67.0123 13.3289C65.9937 14.3353 65.1948 15.5419 64.666 16.8725C64.1372 18.2032 63.8899 19.629 63.9399 21.06C63.9399 27.95 68.7999 32.06 75.5199 32.06C80.5899 32.06 84.0399 29.94 85.5199 25.73L80.5699 23.8ZM69.7999 18.42C70.0489 17.2966 70.6876 16.2977 71.6029 15.6003C72.5181 14.9029 73.6507 14.552 74.7999 14.61C77.4199 14.61 79.1999 16.02 79.1999 18.24V18.42H69.7999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.26 23.8C102.025 24.9246 101.387 25.9245 100.466 26.6114C99.5452 27.2984 98.405 27.6251 97.2601 27.53C94.1501 27.53 91.6001 25.65 91.5301 22.32H106.26C106.448 21.4495 106.539 20.5606 106.53 19.67C106.53 13.67 102.46 10.35 96.4701 10.35C95.0397 10.2828 93.6111 10.5128 92.2741 11.0256C90.9372 11.5383 89.7211 12.3226 88.7025 13.3289C87.6839 14.3353 86.885 15.5419 86.3562 16.8725C85.8273 18.2032 85.5801 19.629 85.6301 21.06C85.6301 27.95 90.4901 32.06 97.2101 32.06C102.28 32.06 105.73 29.94 107.21 25.73L102.26 23.8ZM91.4901 18.42C91.7391 17.2966 92.3778 16.2977 93.2931 15.6003C94.2083 14.9029 95.3409 14.552 96.4901 14.61C99.1101 14.61 100.89 16.02 100.89 18.24V18.42H91.4901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.13 32.12V26.83H114.84L126.78 15.2V10.36H107.88V15.36H119.42L107.52 27.06V32.06L127.13 32.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.21 23.8C143.975 24.9246 143.337 25.9245 142.416 26.6114C141.495 27.2984 140.355 27.6251 139.21 27.53C136.1 27.53 133.55 25.65 133.48 22.32H148.21C148.398 21.4495 148.489 20.5606 148.48 19.67C148.48 13.67 144.41 10.35 138.42 10.35C136.99 10.2828 135.561 10.5128 134.224 11.0256C132.887 11.5383 131.671 12.3226 130.652 13.3289C129.634 14.3353 128.835 15.5419 128.306 16.8725C127.777 18.2032 127.53 19.629 127.58 21.06C127.58 27.95 132.44 32.06 139.16 32.06C144.23 32.06 147.68 29.94 149.16 25.73L144.21 23.8ZM133.44 18.42C133.689 17.2966 134.328 16.2977 135.243 15.6003C136.158 14.9029 137.291 14.552 138.44 14.61C141.06 14.61 142.84 16.02 142.84 18.24V18.42H133.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3301 10.37H26.1201V14.59H33.3301V10.37Z",
    fill: "#40AB5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3301 16.21H26.1201V20.43H33.3301V16.21Z",
    fill: "url(#paint0_linear_20_19484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3301 22.06H26.1201V26.28H33.3301V22.06Z",
    fill: "url(#paint1_linear_20_19484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21 27.9H0V32.12H7.21V27.9Z",
    fill: "url(#paint2_linear_20_19484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.91 27.9H8.69995V32.12H15.91V27.9Z",
    fill: "url(#paint3_linear_20_19484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6299 27.9H17.4199V32.12H24.6299V27.9Z",
    fill: "url(#paint4_linear_20_19484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3301 27.9H26.1201V32.12H33.3301V27.9Z",
    fill: "url(#paint5_linear_20_19484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6299 22.06H17.4199V26.28H24.6299V22.06Z",
    fill: "url(#paint6_linear_20_19484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.91 22.06H8.69995V26.28H15.91V22.06Z",
    fill: "url(#paint7_linear_20_19484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.91 16.21H8.69995V20.43H15.91V16.21Z",
    fill: "url(#paint8_linear_20_19484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.3 17.87V18.49H168V16.8301C168 13.1001 165.66 10.4 161.75 10.4C160.651 10.3472 159.563 10.6311 158.63 11.2136C157.697 11.7962 156.964 12.6497 156.53 13.66V10.4H150.65V32.12H156.53V18.12C156.53 15.9 157.72 14.68 159.53 14.68C160.319 14.739 161.053 15.1073 161.572 15.7048C162.09 16.3022 162.352 17.0805 162.3 17.87Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_19484",
    x1: 29.2763,
    y1: 20.0458,
    x2: 29.2214,
    y2: 15.7453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#33A65E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_19484",
    x1: 25.5431,
    y1: 25.6456,
    x2: 32.9546,
    y2: 21.8575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_19484",
    x1: -0.443,
    y1: 29.5984,
    x2: 6.7489,
    y2: 29.5984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20_19484",
    x1: 8.24945,
    y1: 29.5984,
    x2: 15.4597,
    y2: 29.5984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20_19484",
    x1: 16.9602,
    y1: 29.5984,
    x2: 24.1521,
    y2: 29.5984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20_19484",
    x1: 25.6529,
    y1: 29.5984,
    x2: 32.8448,
    y2: 29.5984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3559A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_20_19484",
    x1: 16.6674,
    y1: 24.8953,
    x2: 24.4449,
    y2: 22.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_20_19484",
    x1: 7.99325,
    y1: 22.3516,
    x2: 15.6976,
    y2: 25.1515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE1938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_20_19484",
    x1: 8.85335,
    y1: 15.1414,
    x2: 14.8375,
    y2: 20.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5A22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_19484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 32.12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezer);
export default __webpack_public_path__ + "static/media/deezer.92d1835674fe5f07e87aacbff8c4a5c2.svg";
export { ForwardRef as ReactComponent };